export default __webpack_public_path__ + "static/media/capsule-landing-main.30576d1a.png";